module.exports = __webpack_public_path__ + "img/ibis-styles-lisboa-centro-marques-de-pombal.e6f80d36.jpg";